import React from "react";
import toSlug from "../../util/Slug";
import Key from "../../util/Key";

const Select = ({
    input,
    register,
    errors,
    where = "preview",
    color = "212529",
    background = "#fff",
    // border = "1px solid #ced4da",
    selectbg = "fff",
    inline,
    showlabel,
}) => {
    const slugData = toSlug(input.label);
    const labelStyles = {
        color: "#" + color,
    };
    const inputStyle = {
        backgroundColor: background,
        // border: border,
        color: "#" + color,
    };

    const optionStyle = {
        backgroundColor: "#" + selectbg,
    };

    const colums = () => {
        if (where == "form") {
            if (inline != false) {
                return inline;
            } else {
                if (input.size == "0") {
                    return "col-sm-6 col-12 mb-3";
                } else {
                    return "col-12 mb-3";
                }
            }
        } else {
            return "";
        }
    };
    return (
        <div className={colums()} key={Key()}>
            <div className="contiene-input">
                {showlabel == true && (
                    <label
                        style={labelStyles}
                        className="form-label"
                        name={input.label && input.label}
                    >
                        {input.label}
                    </label>
                )}

                <select
                    style={inputStyle}
                    className={`input-border form-control orm-control-material
        ${errors[slugData] ? "is-invalid" : ""}`}
                    defaultValue=""
                    {...register(slugData, {
                        required:
                            input.required === "1"
                                ? input.error_message
                                : false,
                    })}
                >
                    <option
                        style={optionStyle}
                        key={"default"}
                        value=""
                        disabled
                    >
                        {input.placeholder}
                    </option>
                    {input.selectedDataArray.map((item) => (
                        <option
                            style={optionStyle}
                            key={item.customData}
                            value={item.customData}
                        >
                            {item.customData}
                        </option>
                    ))}
                </select>
                {errors[slugData] && (
                    <div className="invalid-feedback">
                        {errors[slugData].message}
                    </div>
                )}
            </div>
        </div>
    );
};
export default Select;
